import { useEffect, useState } from "react";
import axios from "axios";
import { APIURL, AUTH_CREDENTIALS_NAME } from "../Constantes";

const getCabecera = () => {
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = {
        Authorization: `bearer ${Token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
    }
    return cabecera;
}

export const useContratacion = ({referencia}) => {
    const [contratacion, setContratacion] = useState({});
    useEffect(() => {
        const getContracion = async () => {
            return await axios.get(`${APIURL}/Contrating/Reference/${referencia}`,
                {
                    headers: getCabecera()
                }).then(Response => {
                    setContratacion(Response.data)
                }).catch(Error => {
                    setContratacion({})
                })
        }
        getContracion();
        return () => {
            setContratacion({})
        }
    }, [referencia])
    return [contratacion];
}